export default {
  "advent": {
    "season": "Advent",
    "feria": "{{day}} of the {{week}} week of Advent",
    "sunday": "{{week}} Sunday of Advent"
  },
  "christmastide": {
    "season": "Christmas",
    "day": "{{day}} of Christmastide",
    "octave": "{{count}} day in the Octave of Christmas",
    "sunday": "{{count}} Sunday of Christmas"
  },
  "epiphany": {
    "season": "Epiphany",
    "before": "{{day}} before Epiphany",
    "after": "{{day}} after Epiphany"
  },
  "ordinaryTime": {
    "season": "Ordinary Time",
    "feria": "{{day}} of the {{week}} week of Ordinary Time",
    "sunday": "{{week}} Sunday of Ordinary Time"
  },
  "lent": {
    "season": "Lent",
    "feria": "{{day}} of the {{week}} week of Lent",
    "sunday": "{{week}} Sunday of Lent",
    "day_after_ash_wed": "{{day}} after Ash Wednesday"
  },
  "holyWeek": {
    "season": "Holy Week",
    "feria": "{{day}} of Holy Week"
  },
  "eastertide": {
    "season": "Eastertide",
    "feria": "{{day}} of the {{week}} week of Easter",
    "sunday": "{{week}} Sunday of Easter",
    "octave": "Easter {{day}}"
  },
  "celebrations": {
    "allSaints": "All Saints",
    "annunciation": "Annunciation",
    "ascension": "Ascension of the Lord",
    "ashWednesday": "Ash Wednesday",
    "assumption": "The Assumption of the Blessed Virgin Mary",
    "baptismOfTheLord": "Baptism of the Lord",
    "birthOfJohnTheBaptist": "Birth of John the Baptist",
    "christmas": "Christmas",
    "christTheKing": "Christ the King",
    "corpusChristi": "Corpus Christi",
    "divineMercySunday": "Divine Mercy Sunday",
    "easter": "Easter Sunday",
    "epiphany": "Epiphany",
    "goodFriday": "Good Friday",
    "holyFamily": "Holy Family",
    "holySaturday": "Holy Saturday/Easter Vigil",
    "holyThursday": "Holy Thursday",
    "immaculateConception": "Immaculate Conception",
    "immaculateHeartOfMary": "Immaculate Heart of Mary",
    "josephHusbandOfMary": "Joseph, Husband of Mary",
    "maryMotherOfGod": "Mary, Mother of God",
    "palmSunday": "Palm Sunday",
    "pentecostSunday": "Pentecost Sunday",
    "peterAndPaulApostles": "Saints Peter and Paul, Apostles",
    "presentationOfTheLord": "Presentation of the Lord",
    "sacredHeartOfJesus": "Sacred Heart of Jesus",
    "theExaltationOfTheHolyCross": "The Exaltation of the Holy Cross",
    "transfiguration": "Transfiguration",
    "trinitySunday": "Trinity Sunday"
  },
  "sanctoral": {
    "205BlessedMartyrsOfJapan": "205 Blessed Martyrs of Japan",
    "allSaintsOfIreland": "All Saints of Ireland",
    "allSaintsOfWales": "All Saints of Wales",
    "allSouls": "All Souls",
    "birthOfTheBlessedVirginMary": "Birth of the Blessed Virgin Mary",
    "blessedAlbertinaBerkenbrockVirginAndMartyr": "Blessed Albertina Berkenbrock, Virgin and Martyr",
    "blessedAloysiusStepinacBishopAndMartyr": "Blessed Aloysius Stepinac, Bishop and Martyr",
    "blessedAndreGrassetPriestAndMartyr": "Blessed Andre Grasset, Priest and Martyr",
    "blessedAnielaSalawaVirgin": "Blessed Aniela Salawa, Virgin",
    "blessedAntoniNowowiejskiBishopAndCompanionsMartyrs": "Blessed Antoni Nowowiejski, Bishop and Companions, Martyrs",
    "blessedAugustinKazoticBishopAndMartyr": "Blessed Augustin Kazotic, Bishop and Martyr",
    "blessedBartholomewOfTheMartyrsBishop": "Blessed Bartholomew of The Martyrs, Bishop",
    "blessedBartolomeLaurelReligiousAndMartyr": "Blessed Bartolome Laurel, Religious and Martyr",
    "blessedBogumilBishop": "Blessed Bogumil, Bishop",
    "blessedBoleslawaMariaLamentVirginAndSaintAngelaMericiVirgin": "Blessed Boleslawa Maria Lament, Virgin/Saint Angela Merici, Virgin",
    "blessedBronislawaVirgin": "Blessed Bronislawa, Virgin",
    "blessedBronislawMarkiewiczPriest": "Blessed Bronislaw Markiewicz, Priest",
    "blessedCarlosManuelRodriguez": "Blessed Carlos Manuel Rodriguez",
    "blessedCatherineOfSaintAugustineVirgin": "Blessed Catherine of Saint Augustine, Virgin",
    "blessedCeferinoNamuncura": "Blessed Ceferino Namuncura",
    "blessedCeslausAndSaintHyacinthPriests": "Blessed Ceslaus and Saint Hyacinth, Priests",
    "blessedCharlesSpinolaPriestAndMartyr": "Blessed Charles Spinola, Priest and Martyr",
    "blessedColumbaMarmionPriest": "Blessed Columba Marmion, Priest",
    "blessedCzeslawPriest": "Blessed Czeslaw, Priest",
    "blessedDinaBelangerVirgin": "Blessed Dina Belanger, Virgin",
    "blessedDominicOfTheMotherOfGodDominicBarberiPriest": "Blessed Dominic of The Mother of God (Dominic Barberi), Priest",
    "blessedEdmundBojanowski": "Blessed Edmund Bojanowski",
    "blessedEdmundIgnatiusRiceReligious": "Blessed Edmund Ignatius Rice, Religious",
    "blessedElisabethHesselbaldVirgin": "Blessed Elisabeth Hesselbald, Virgin",
    "blessedEmilieTavernierGamelinReligious": "Blessed Emilie Tavernier Gamelin, Religious",
    "blessedFredericJanssoonePriest": "Blessed Frederic Janssoone, Priest",
    "blessedGeorgeMatulewiczBishop": "Blessed George Matulewicz, Bishop",
    "blessedGisela": "Blessed Gisela",
    "blessedGoncaloDeAmarantePriest": "Blessed Goncalo de Amarante, Priest",
    "blessedGoncaloDeLagosPriest": "Blessed Goncalo de Lagos, Priest",
    "blessedGraziaOfCattaro": "Blessed Grazia of Cattaro",
    "blessedHemmingBishop": "Blessed Hemming, Bishop",
    "blessedHenrySusoPriest": "Blessed Henry Suso, Priest",
    "blessedHonoratKozminskiPriest": "Blessed Honorat Kozminski, Priest",
    "blessedHroznataMartyr": "Blessed Hroznata, Martyr",
    "blessedInacioDeAzevedoPriestAndCompanionsMartyrs": "Blessed Inacio de Azevedo, Priest, and Companions, Martyrs",
    "blessedInnocentXiPope": "Blessed Innocent XI, Pope",
    "blessedIrishMartyrs": "Blessed Irish Martyrs",
    "blessedIstvanSandorMartyr": "Blessed István Sándor, Martyr",
    "blessedIvanMerz": "Blessed Ivan Merz",
    "blessedJacintaAndFranciscoMarto": "Blessed Jacinta and Francisco Marto",
    "blessedJakubStrzemieBishop": "Blessed Jakub Strzemie, Bishop",
    "blessedJerzyMatulewiczBishop": "Blessed Jerzy Matulewicz, Bishop",
    "blessedJoanOfPortugalVirgin": "Blessed Joan of Portugal, Virgin",
    "blessedJohnBeyzymPriest": "Blessed John Beyzym, Priest",
    "blessedJohnHenryNewmanPriest": "Blessed John Henry Newman, Priest",
    "blessedJohnMartinMoyePriest": "Blessed John Martin Moye, Priest",
    "blessedJolantaReligious": "Blessed Jolanta, Religious",
    "blessedJosephVazPriest": "Blessed Joseph Vaz, Priest",
    "blessedJuniperoSerraPriest": "Blessed Junipero Serra, Priest",
    "blessedKarlOfAustria": "Blessed Karl of Austria",
    "blessedKarolinaKozkownaVirginAndMartyr": "Blessed Karolina Kozkowna, Virgin and Martyr",
    "blessedKuriakoseEliasChavaraPriest": "Blessed Kuriakose Elias Chavara, Priest",
    "blessedLauraVicunaVirgin": "Blessed Laura Vicuna, Virgin",
    "blessedLouisZephirinMoreauBishop": "Blessed Louis Zephirin Moreau, Bishop",
    "blessedMarcelinaDarowskaReligious": "Blessed Marcelina Darowska, Religious",
    "blessedMariaAdeodataPisaniVirgin": "Blessed Maria Adeodata Pisani, Virgin",
    "blessedMariaAssuntaPallottaVirgin": "Blessed Maria Assunta Pallotta, Virgin",
    "blessedMariaDoloresRodriguezSopenaVirgin": "Blessed Maria Dolores Rodriguez Sopena, Virgin",
    "blessedMariaStellaAndCompanionsVirginsAndMartyrs": "Blessed Maria Stella and Companions, Virgins and Martyrs",
    "blessedMariaTeresaLedochowskaVirgin": "Blessed Maria Teresa Ledochowska, Virgin",
    "blessedMariaTheresaChiramelVirgin": "Blessed Maria Theresa Chiramel, Virgin",
    "blessedMarieAnneBlondinVirgin": "Blessed Marie Anne Blondin, Virgin",
    "blessedMarieLeonieParadisVirgin": "Blessed Marie Leonie Paradis, Virgin",
    "blessedMarieRoseDurocherVirgin": "Blessed Marie Rose Durocher, Virgin",
    "blessedMaryAngelaTruszkowskaVirgin": "Blessed Mary Angela Truszkowska, Virgin",
    "blessedMaryOfJesusCrucifiedPetkovicVirgin": "Blessed Mary of Jesus Crucified Petkovic, Virgin",
    "blessedMaryOfJesusTheGoodShepherdVirgin": "Blessed Mary of Jesus The Good Shepherd, Virgin",
    "blessedMauriceTornayPriestAndMartyr": "Blessed Maurice Tornay, Priest and Martyr",
    "blessedMichaelKozalBishopAndMartyr": "Blessed Michael Kozal, Bishop and Martyr",
    "blessedMiguelAgustinProPriestAndMartyr": "Blessed Miguel Agustin Pro, Priest and Martyr",
    "blessedNazariaIgnaciaMarchReligious": "Blessed Nazaria Ignacia March, Religious",
    "blessedNazjuFalzon": "Blessed Nazju Falzon",
    "blessedNicolasStenoBishop": "Blessed Nicolas Steno, Bishop",
    "blessedOdoricOfPordenonePriest": "Blessed Odoric of Pordenone, Priest",
    "blessedOleksiyZarytskyiPriestAndMartyr": "Blessed Oleksiy Zarytskyi, Priest and Martyr",
    "blessedOsannaOfCattaroVirgin": "Blessed Osanna of Cattaro, Virgin",
    "blessedPeterKibePriestAndCompanionsMartyrs": "Blessed Peter Kibe, Priest and Companions, Martyrs",
    "blessedPeterToRotMartyr": "Blessed Peter To Rot, Martyr",
    "blessedPiusIxPope": "Blessed Pius IX, Pope",
    "blessedRafalChylinskiPriest": "Blessed Rafal Chylinski, Priest",
    "blessedSalomeVirgin": "Blessed Salome, Virgin",
    "blessedSanchaAndMafaldaVirginsOrBlessedTheresaOfPOrtugalReligious": "Blessed Sancha and Mafalda, Virgins, Or Blessed Theresa of POrtugal, Religious",
    "blessedsAndreDeSoveralAndAmbrosioFranciscoFerroPriestsAndMartyrs": "Blesseds Andre de Soveral and Ambrosio Francisco Ferro, Priests and Martyrs",
    "blessedSaraSalkahaziVirginAndMartyr": "Blessed Sara Salkahazi, Virgin and Martyr",
    "blessedsCarlosSpinolaAndJeronimoDeAngelisPriestsAndMartyrs": "Blesseds Carlos Spinola and Jeronimo de Angelis, Priests and Martyrs",
    "blessedSebastianDeAparicioReligious": "Blessed Sebastian de Aparicio, Religious",
    "blessedsNykytaBudkaAndVasylVelychkowskyBishopsAndMartyrs": "Blesseds Nykyta Budka and Vasyl Velychkowsky, Bishops and Martyrs",
    "blessedsPedroZunigaAndLuisFloresPriestsAndMartyrs": "Blesseds Pedro Zuniga And Luis Flores, Priests and Martyrs",
    "blessedTheodoreRomzhaBishopAndMartyr": "Blessed Theodore Romzha, Bishop and Martyr",
    "blessedVilmosAporBishopAndMartyr": "Blessed Vilmos Apor, Bishop and Martyr",
    "blessedVincentKadlubekBishop": "Blessed Vincent Kadlubek, Bishop",
    "blessedVincentLewoniukAndCompanionsMartyrsOfPratulin": "Blessed Vincent Lewoniuk and Companions, Martyrs Of Pratulin",
    "blessedVladimirGhikaPriestAndMartyr": "Blessed Vladimir Ghika, Priest and Martyr",
    "blessedWladyslawBladzinskiPriestAndCompanionsMartyrs": "Blessed Wladyslaw Bladzinski, Priest and Companions, Martyrs",
    "blessedWladyslawOfGielniowPriest": "Blessed Wladyslaw Of Gielniow, Priest",
    "blessedZdenkaSchelingovaVirginAndMartyr": "Blessed Zdenka Schelingova, Virgin and Martyr",
    "chairOfSaintPeterApostle": "Chair of Saint Peter, Apostle",
    "conversionOfSaintPaulApostle": "Conversion of Saint Paul, Apostle",
    "dedicationOfAParticularChurch": "Dedication of a particular Church",
    "dedicationOfTheBasilicaOfSaintMaryMajor": "Dedication of the Basilica of Saint Mary Major",
    "dedicationOfTheBasilicasOfSaintsPeterAndPaulApostles": "Dedication of the basilicas of Saints Peter and Paul, Apostles",
    "dedicationOfTheLateranBasilica": "Dedication of the Lateran Basilica",
    "discoveryOfTheHiddenChristians": "Discovery of The Hidden Christians",
    "findingOfTheHolyCross": "Finding of The Holy Cross",
    "firstMartyrsOfTheChurchOfRome": "First Martyrs of the Church of Rome",
    "guardianAngelOfPortugal": "Guardian Angel of Portugal",
    "guardianAngels": "Guardian Angels",
    "holyInnocentsMartyrs": "Holy Innocents, Martyrs",
    "holyNameOfTheBlessedVirginMary": "Holy Name of the Blessed Virgin Mary",
    "hungarianSaintsAndBlesseds": "Hungarian Saints and Blesseds",
    "immaculateConceptionOfTheBlessedVirginMaryPrincipalPatronessOfThePhilippines": "Immaculate Conception of The Blessed Virgin Mary, Principal Patroness Of The Philippines",
    "maryMotherOfTheChurch": "Mary, Mother of The Church",
    "mostHolyNameOfJesusOrOurLadyOfBethlehem": "Most Holy Name of Jesus Or Our Lady of Bethlehem",
    "ourLadyHelpOfChristians": "Our Lady, Help of Christians",
    "ourLadyMediatrix": "Our Lady, Mediatrix",
    "ourLadyMediatrixOfAllGrace": "Our Lady, Mediatrix of All Grace",
    "ourLadyMotherOfChristianUnity": "Our Lady, Mother of Christian Unity",
    "ourLadyMotherOfDivineProvidencePatronessOfPuertoRico": "Our Lady, Mother of Divine Providence, Patroness of Puerto Rico",
    "ourLadyMotherOfMercy": "Our Lady, Mother of Mercy",
    "ourLadyOfAparecidaPatronessOfBrazil": "Our Lady of Aparecida (Nossa Senhora Aparecida), Patroness of Brazil",
    "ourLadyOfBistrica": "Our Lady of Bistrica",
    "ourLadyOfChina": "Our Lady of China",
    "ourLadyOfCzestochowa": "Our Lady of Czestochowa",
    "ourLadyOfFatima": "Our Lady of Fatima",
    "ourLadyOfGoodCounsel": "Our Lady of Good Counsel",
    "ourLadyOfGuadalupe": "Our Lady of Guadalupe",
    "ourLadyOfHungary": "Our Lady of Hungary",
    "ourLadyOfItati": "Our Lady of Itati",
    "ourLadyOfKnock": "Our Lady of Knock",
    "ourLadyOfLanka": "Our Lady of Lanka",
    "ourLadyOfLebanon": "Our Lady of Lebanon",
    "ourLadyOfLoreto": "Our Lady of Loreto",
    "ourLadyOfLourdes": "Our Lady of Lourdes",
    "ourLadyOfLujanPatronessOfArgentina": "Our Lady of Luján, Patroness of Argentina",
    "ourLadyOfMadhu": "Our Lady of Madhu",
    "ourLadyOfMercy": "Our Lady of Mercy",
    "ourLadyOfMountCarmel": "Our Lady of Mount Carmel",
    "ourLadyOfMountCarmelMotherAndQueenOfChile": "Our Lady of Mount Carmel, Mother and Queen of Chile",
    "ourLadyOfPeace": "Our Lady of Peace",
    "ourLadyOfPerpetualHelpOrBlessedLeonidFeodorovPriestAndMartyr": "Our Lady of Perpetual Help Or Blessed Leonid Feodorov, Priest and Martyr",
    "ourLadyOfSorrows": "Our Lady of Sorrows",
    "ourLadyOfTheGateOfDawn": "Our Lady of The Gate of Dawn",
    "ourLadyOfThePillar": "Our Lady of The Pillar",
    "ourLadyOfTheRosary": "Our Lady of the Rosary",
    "ourLadyOfTheValley": "Our Lady of The Valley",
    "ourLadyOfVladimir": "Our Lady of Vladimir",
    "ourLadyOfWalsingham": "Our Lady of Walsingham",
    "ourLadyQueenOfPeace": "Our Lady, Queen of Peace",
    "ourLadyQueenOfPoland": "Our Lady, Queen of Poland",
    "ourLordJesusChristTheEternalHighPriest": "Our Lord Jesus Christ, The Eternal High Priest",
    "ourLordOfMiracles": "Our Lord of Miracles",
    "popeSaintJohnPaulII": "Pope Saint John Paul II",
    "popeSaintJohnXXIII": "Pope Saint John XXIII",
    "presentationOfTheBlessedVirginMary": "Presentation of The Blessed Virgin Mary",
    "queenshipOfBlessedVirginMary": "Queenship of Blessed Virgin Mary",
    "saintAdalbertBishopAndMartyr": "Saint Wojciech (Adalbert of Prague), Bishop and Martyr",
    "saintAdalbertBishopAndMartyrSaintFidelisOfSigmaringenPriestAndMartyr": "Saint Wojciech (Adalbert of Prague), Bishop and Martyr/Saint Fidelis of Sigmaringen, Priest and Martyr",
    "saintAelredOfRievaulx": "Saint Aelred of Rievaulx",
    "saintAengusOengusBishopAndAbbot": "Saint Aengus (Oengus), Bishop and Abbot",
    "saintAgathaVirginAndMartyr": "Saint Agatha, Virgin and Martyr",
    "saintAgnesCaoGuiyingMartyr": "Saint Agnes Cao Guiying, Martyr",
    "saintAgnesOfBohemiaVirgin": "Saint Agnes of Bohemia, Virgin",
    "saintAgnesVirginAndMartyr": "Saint Agnes, Virgin and Martyr",
    "saintAidanBishop": "Saint Aidan, Bishop",
    "saintAidanBishopAndTheSaintsOfLindisfarne": "Saint Aidan, Bishop and The Saints of Lindisfarne",
    "saintAidanOfLindisfarneBishopAndMissionary": "Saint Aidan of Lindisfarne, Bishop and Missionary",
    "saintAilbeBishop": "Saint Ailbe, Bishop",
    "saintAlbanMartyr": "Saint Alban, Martyr",
    "saintAlbericCrescitelliPriestAndMartyr": "Saint Alberic Crescitelli, Priest and Martyr",
    "saintAlbertChmielowskiReligious": "Saint Albert Chmielowski, Religious",
    "saintAlbertoHurtadoPriest": "Saint Alberto Hurtado, Priest",
    "saintAlbertTheGreatBishopAndDoctor": "Saint Albert the Great, Bishop and Doctor",
    "saintAloysiusGonzagaReligious": "Saint Aloysius Gonzaga, Religious",
    "saintAlphonsaOfTheImmaculateConceptionVirgin": "Saint Alphonsa of The Immaculate Conception, Virgin",
    "saintAlphonsusMariaDeLiguoriBishopAndDoctorOfTheChurch": "Saint Alphonsus Maria de Liguori, Bishop and Doctor of the Church",
    "saintAmandMissionary": "Saint Amand, Missionary",
    "saintAmbroseBishopAndDoctor": "Saint Ambrose, Bishop and Doctor",
    "saintAndreBessetteReligious": "Saint Andre Bessette, Religious",
    "saintAndrewApostle": "Saint Andrew, Apostle",
    "saintAndrewBobolaPriestAndMartyr": "Saint Andrew Bobola, Priest and Martyr",
    "saintAndrewDungLacAndCompanionsMartyrs": "Saint Andrew Dung-Lac and Companions, Martyrs",
    "saintAndrewKimTaegonPriestAndPaulChongHasangAndCompanionsMartyrs": "Saint Andrew Kim Taegon, Priest, and Paul Chong Hasang and Companions, Martyrs",
    "saintAndrewTheApostle": "Saint Andrew the Apostle",
    "saintAndrewTheApostlePatronOfRussia": "Saint Andrew The Apostle, Patron of Russia",
    "saintAngelaMericiVirgin": "Saint Angela Merici, Virgin",
    "saintAnnePatronOfQuebecAndSaintJoachimParentsOfTheBlessedVirginMary": "Saint Anne, Patron of Quebec, and Saint Joachim, Parents of The Blessed Virgin Mary",
    "saintAnnoIiBishop": "Saint Anno II, Bishop",
    "saintAnselmOfCanterburyBishopAndDoctorOfTheChurch": "Saint Anselm of Canterbury, Bishop and Doctor of the Church",
    "saintAnthonyMaryClaretBishop": "Saint Anthony Mary Claret, Bishop",
    "saintAnthonyOfEgyptAbbot": "Saint Anthony of Egypt, Abbot",
    "saintAnthonyOfLisbonPriestAndDoctorOfTheChurch": "Saint Anthony of Lisbon, Priest and Doctor of The Church",
    "saintAnthonyOfPaduaPriestAndDoctor": "Saint Anthony of Padua, Priest and Doctor",
    "saintAnthonyOfSaintAnneGalvaoFreiGalvaoPriest": "Saint Anthony of Saint Anne Galvao (Frei Galvao), Priest",
    "saintAnthonyOfTheCavesMonk": "Saint Anthony of The Caves, Monk",
    "saintAnthonyZaccariaPriest": "Saint Anthony Zaccaria, Priest",
    "saintApollinaris": "Saint Apollinaris",
    "saintAsaphBishop": "Saint Asaph, Bishop",
    "saintAsicusBishop": "Saint Asicus, Bishop",
    "saintAthanasiusBishopAndDoctor": "Saint Athanasius, Bishop and Doctor",
    "saintAugustineOfCanterburyBishop": "Saint Augustine of Canterbury, Bishop",
    "saintAugustineOfHippoBishopAndDoctorOfTheChurch": "Saint Augustine of Hippo, Bishop and Doctor of the Church",
    "saintAugustineZhaoRongPriestAndCompanionsMartyrs": "Saint Augustine Zhao Rong, Priest and Companions, Martyrs",
    "saintAugustineZhaoRongPriestAndMartyr": "Saint Augustine Zhao Rong, Priest and Martyr",
    "saintBarbaraVirginAndMartyr": "Saint Barbara, Virgin and Martyr",
    "saintBarbaraVirginAndMartyrOrBlessedAdolphKolpingPriest": "Saint Barbara, Virgin and Martyr/Blessed Adolph Kolping, Priest",
    "saintBarnabasTheApostle": "Saint Barnabas the Apostle",
    "saintBartholomewTheApostle": "Saint Bartholomew the Apostle",
    "saintBeatriceOfSilvaVirgin": "Saint Beatrice of Silva, Virgin",
    "saintBedeTheVenerablePriestAndDoctor": "Saint Bede the Venerable, Priest and Doctor of the Church",
    "saintBedeTheVenerablePriestAndDoctorSaintGregoryViiPopeSaintMaryMagdaleneDePazziVirgin": "Saint Bede the Venerable, Priest and Doctor/Saint Gregory VII, Pope/Saint Mary Magdalene de Pazzi, Virgin",
    "saintBenedictOfNursiaAbbot": "Saint Benedict of Nursia, Abbot, Patron of Europe",
    "saintBennoOfMeissenBishop": "Saint Benno of Meissen, Bishop",
    "saintBernadetteSoubirousVirgin": "Saint Bernadette Soubirous, Virgin",
    "saintBernardineOfSienaPriest": "Saint Bernardine of Siena, Priest",
    "saintBernardOfClairvauxAbbotAndDoctorOfTheChurch": "Saint Bernard of Clairvaux, Abbot and Doctor of the Church",
    "saintBeunoAbbot": "Saint Beuno, Abbot",
    "saintBlaseBishopAndMartyrSaintAnsgarBishop": "Saint Blase, Bishop Martyr and Saint Ansgar, Bishop",
    "saintBonaventureBishopAndDoctor": "Saint Bonaventure, Bishop and Doctor",
    "saintBonifaceBishopAndMartyr": "Saint Boniface, Bishop and Martyr",
    "saintBrendanAbbot": "Saint Brendan, Abbot",
    "saintBridgetOfSwedenReligious": "Saint Bridget of Sweden, Religious, Patron of Europe",
    "saintBrigidVirgin": "Saint Brigid, Virgin",
    "saintBrotherMutienMarieReligious": "Saint Brother Mutien Marie, Religious",
    "saintBrunoBonifaceOfQuerfurtBishopAndMartyr": "Saint Bruno Boniface Of Querfurt, Bishop And Martyr",
    "saintBrunoPriest": "Saint Bruno, Priest",
    "saintCaesariusOfArlesBishop": "Saint Caesarius of Arles, Bishop",
    "saintCallistusIPopeAndMartyr": "Saint Callistus I, Pope and Martyr",
    "saintCamillusDeLellisPriest": "Saint Camillus de Lellis, Priest",
    "saintCamillusDeLellisPriestOrSaintHenryBishopAndMartyr": "Saint Camillus de Lellis, Priest or Saint Henry, Bishop and Martyr",
    "saintCaniceAbbot": "Saint Canice, Abbot",
    "saintCanuteMartyr": "Saint Canute, Martyr",
    "saintCarthageBishopMochuta": "Saint Carthage, Bishop (Mochuta)",
    "saintCasimir": "Saint Casimir",
    "saintCatherineOfAlexandriaVirginAndMartyr": "Saint Catherine of Alexandria, Virgin and Martyr",
    "saintCatherineOfSienaVirginAndDoctorOfTheChurch": "Saint Catherine of Siena, Virgin and Doctor of The Church, Patron of Europe",
    "saintCeallachCelsusBishop": "Saint Ceallach (Celsus), Bishop",
    "saintCeciliaVirginAndMartyr": "Saint Cecilia, Virgin and Martyr",
    "saintCharbelMakhloufPriestAndHermit": "Saint Charbel Makhlouf, Priest and Hermit",
    "saintCharlesBorromeoBishop": "Saint Charles Borromeo, Bishop",
    "saintChristopherMagallanesAndCompanionsMartyrs": "Saint Christopher Magallanes and Companions, Martyrs",
    "saintChristopherMartyr": "Saint Christopher, Martyr",
    "saintCiaranAbbot": "Saint Ciaran, Abbot",
    "saintClareVirgin": "Saint Clare, Virgin",
    "saintClementIPopeAndMartyrSaintColumbanReligious": "Saint Clement I, Pope and Martyr/Saint Columban, Religious",
    "saintClementMaryHofbauerPriest": "Saint Clement Mary Hofbauer, Priest",
    "saintClementOfOhridAndGorazdBishopsAndCompanions": "Saint Clement of Ohrid and Gorazd, Bishops and Companions",
    "saintClotilde": "Saint Clotilde",
    "saintColmanOfCloyneBishop": "Saint Colman of Cloyne, Bishop",
    "saintColmanOfDromoreBishop": "Saint Colman of Dromore, Bishop",
    "saintColmanOfKilmacduaghBishop": "Saint Colman of Kilmacduagh, Bishop",
    "saintColumba": "Saint Columba",
    "saintColumbaAbbotAndMissionary": "Saint Columba, Abbot and Missionary",
    "saintColumbanAbbotAndMissionary": "Saint Columban, Abbot and Missionary",
    "saintComgallAbbot": "Saint Comgall, Abbot",
    "saintConlethBishop": "Saint Conleth, Bishop",
    "saintConradOfParzhamReligious": "Saint Conrad of Parzham, Religious",
    "saintCorbinianBishop": "Saint Corbinian, Bishop",
    "saintCuthbertBishop": "Saint Cuthbert, Bishop",
    "saintCyrilOfAlexandriaBishopAndDoctor": "Saint Cyril of Alexandria, Bishop and Doctor",
    "saintCyrilOfJerusalemBishopAndDoctor": "Saint Cyril of Jerusalem, Bishop and Doctor",
    "saintDamasusIPope": "Saint Damasus I, Pope",
    "saintDamienDeVeusterPriest": "Saint Damien de Veuster, Priest",
    "saintDavidBishop": "Saint David, Bishop",
    "saintDavidLewisPriestAndMartyr": "Saint David Lewis, Priest and Martyr",
    "saintDavnetVirgin": "Saint Davnet, Virgin",
    "saintDeclanBishop": "Saint Declan, Bishop",
    "saintDeiniolBishop": "Saint Deiniol, Bishop",
    "saintDemetrius": "Saint Demetrius",
    "saintDenisAndCompanionsMartyrsSaintJohnLeonardiPriest": "Saint Denis and Companions Martyrs/Saint John Leonardi, Priest",
    "saintDenisAndCompanionsMartyrsSaintJohnLeonardiPriestBlessedJohnNewmanBishop": "Saint Denis and Companions, Martyrs/Saint John Leonardi, Priest/Blessed John Newman, Bishop",
    "saintDionysiusTheAreopagite": "Saint Dionysius The Areopagite",
    "saintDominicPriest": "Saint Dominic, Priest",
    "saintDominicPriest/SaintSixtusIiPopeAndCompanionsMartyrsSaintCajetanPriest": "Saint Dominic, Priest/Saint Sixtus II, Pope, and Companions, Martyrs/Saint Cajetan, Priest",
    "saintDubriciusBishop": "Saint Dubricius, Bishop",
    "saintEdmundCampionPriestAndMartyr": "Saint Edmund Campion, Priest and Martyr",
    "saintEdmundOfAbingdonBishopOrSaintMargaretOfScotland": "Saint Edmund of Abingdon, Bishop Or Saint Margaret of Scotland",
    "saintEdwardTheConfessor": "Saint Edward The Confessor",
    "saintElijahProphet": "Saint Elijah, prophet",
    "saintElizabethAnnSetonReligious": "Saint Elizabeth Ann Seton, Religious",
    "saintElizabethOfHungary": "Saint Elizabeth of Hungary",
    "saintElizabethOfHungarySaintHildaAbbessSaintHughOfLincolnBishop": "Saint Elizabeth of Hungary, Religious/Saint Hilda, Abbess/Saint Hugh of Lincoln, Bishop",
    "saintElizabethOfPortugal": "Saint Elizabeth of Portugal",
    "saintEmeric": "Saint Emeric",
    "saintEndaAbbot": "Saint Enda, Abbot",
    "saintEphraemDeaconDoctorOrSaintColumbaColumCilleAbbot": "Saint Ephraem, Deacon, Doctor or Saint Columba (Colum Cille), Abbot",
    "saintEphremDeaconAndDoctor": "Saint Ephrem, Deacon and Doctor",
    "saintEricIxMartyr": "Saint Eric IX, Martyr",
    "saintEtheldredaAudreyVirgin": "Saint Etheldreda (Audrey), Virgin",
    "saintEugeneDeMazenodBishop": "Saint Eugene de Mazenod, Bishop",
    "saintEugeneEoghanBishop": "Saint Eugene (Eoghan), Bishop",
    "saintEulaliaOfMeridaVirginAndMartyr": "Saint Eulalia of Merida, Virgin and Martyr",
    "saintEulogiusOfCordobaBishop": "Saint Eulogius of Cordoba, Bishop",
    "saintEusebiusOfVercelliBishopSaintPeterJulianEymardPriest": "Saint Eusebius of Vercelli, Bishop/Saint Peter Julian Eymard, Priest",
    "saintEysteinnBishop": "Saint Eysteinn, Bishop",
    "saintEzekielMorenoBishop": "Saint Ezekiel Moreno, Bishop",
    "saintEzequielMorenoBishop": "Saint Ezequiel Moreno, Bishop",
    "saintFachananOfKilfenoraBishop": "Saint Fachanan of Kilfenora, Bishop",
    "saintFachtnaBishop": "Saint Fachtna, Bishop",
    "saintFaustinaKowalskaVirginAndReligious": "Saint Faustina Kowalska, Virgin and Religious",
    "saintFelipeDeJesusPriestAndMartyr": "Saint Felipe de Jesus, Priest And Martyr",
    "saintFerdinand": "Saint Ferdinand",
    "saintFergalBishopAndMissionary": "Saint Fergal, Bishop and Missionary",
    "saintFiacreMonk": "Saint Fiacre, Monk",
    "saintFidelisOfSigmaringenPriestAndMartyr": "Saint Fidelis of Sigmaringen, Priest and Martyr",
    "saintFinbarrBishop": "Saint Finbarr, Bishop",
    "saintFinnianOfClonardBishop": "Saint Finnian of Clonard, Bishop",
    "saintFintan": "Saint Fintan",
    "saintFlannanBishop": "Saint Flannan, Bishop",
    "saintFlorianAndHisCompanionsMartyrs": "Saint Florian and his Companions, Martyrs",
    "saintFlorianMartyr": "Saint Florian, Martyr",
    "saintFrancesOfRomeReligious": "Saint Frances of Rome, Religious",
    "saintFrancesXavierCabriniVirgin": "Saint Frances Xavier Cabrini, Virgin",
    "saintFrancisBorgiaPriest": "Saint Francis Borgia, Priest",
    "saintFrancisDeSalesBishopAndDoctor": "Saint Francis de Sales, Bishop and Doctor",
    "saintFrancisDiazPriestAndCompanionsMartyrs": "Saint Francis Diaz, Priest and Companions, Martyrs",
    "saintFrancisFernandezDeCapillasPriestAndMartyr": "Saint Francis Fernandez de Capillas, Priest and Martyr",
    "saintFrancisOfAssisi": "Saint Francis of Assisi",
    "saintFrancisOfPaolaHermit": "Saint Francis of Paola, Hermit",
    "saintFrancisSolanusPriest": "Saint Francis Solanus, Priest",
    "saintFrancisXavierPriest": "Saint Francis Xavier, Priest",
    "saintFrancoisDeLavalBishop": "Saint Francois de Laval, Bishop",
    "saintFridolinOfSackingenMonk": "Saint Fridolin of Säckingen, Monk",
    "saintFructuosusSaintMartinOfDumeAndSaintGeraldBishops": "Saint Fructuosus, Saint Martin of Dume and Saint Gerald, Bishops",
    "saintFursaAbbotAndMissionary": "Saint Fursa, Abbot and Missionary",
    "saintGabrieltaurinDufresseBishopAndMartyr": "Saint Gabriel-Taurin Dufresse, Bishop and Martyr",
    "saintGallAbbotAndMissionary": "Saint Gall, Abbot & Missionary",
    "saintGenevieveVirgin": "Saint Genevieve, Virgin",
    "saintGeorgeMartyr": "Saint George, Martyr",
    "saintGeorgeMartyrSaintAdalbertBishopAndMartyr": "Saint George, Martyr/Saint Adalbert, Bishop and Martyr",
    "saintGeorgePrecaPriest": "Saint George Preca, Priest",
    "saintGerardBishop": "Saint Gerard, Bishop",
    "saintGermanusOfAuxerreBishop": "Saint Germanus of Auxerre, Bishop",
    "saintGertrudeOfNivellesAbbess": "Saint Gertrude of Nivelles, Abbess",
    "saintGertrudeOfNivellesVirgin": "Saint Gertrude of Nivelles, Virgin",
    "saintGertrudeTheGreatVirgin": "Saint Gertrude The Great, Virgin",
    "saintGobnaitVirgin": "Saint Gobnait, Virgin",
    "saintGonsaloGarciaMartyr": "Saint Gonsalo Garcia, Martyr",
    "saintGorazdAndCompanions": "Saint Gorazd and Companions",
    "saintGotthardBishop": "Saint Gotthard, Bishop",
    "saintGregoryTheGreatPopeAndDoctor": "Saint Gregory the Great, Pope and Doctor of the Church",
    "saintHectorValdivielsoSaezMartyr": "Saint Héctor Valdivielso Sáez, Martyr",
    "saintHedwigOfPoland": "Saint Hedwig of Poland",
    "saintHedwigOfSilesia": "Saint Hedwig of Silesia",
    "saintHedwigReligiousOrSaintMargaretMaryAlacoqueVirgin": "Saint Hedwig, Religious Or Saint Margaret Mary Alacoque, Virgin",
    "saintHedwigReligiousSaintMargaretMaryAlacoqueVirgin": "Saint Hedwig, Religious/Saint Margaret Mary Alacoque, Virgin",
    "saintHelena": "Saint Helena",
    "saintHemmaOfGurk": "Saint Hemma of Gurk",
    "saintHenryBishopAndMartyr": "Saint Henry, Bishop and Martyr",
    "saintHermannJosephPriest": "Saint Hermann Joseph, Priest",
    "saintHermenegildMartyr": "Saint Hermenegild, Martyr",
    "saintHilaryOfPoitiersBishopAndDoctor": "Saint Hilary of Poitiers, Bishop and Doctor",
    "saintHildegardOfBingenAbbessAndDoctor": "Saint Hildegard of Bingen, Abbess and Doctor",
    "saintHubertBishop": "Saint Hubert, Bishop",
    "saintHubertOfLiegeBishopOrSaintPirminAbbotAndBishop": "Saint Hubert of Liege, Bishop/Saint Pirmin, Abbot and Bishop",
    "saintHyacinthPriest": "Saint Hyacinth, Priest",
    "saintIgnatiusOfAntiochBishopAndMartyr": "Saint Ignatius of Antioch, Bishop and Martyr",
    "saintIgnatiusOfLoyolaPriest": "Saint Ignatius of Loyola, Priest",
    "saintIldephonsusOfToledoBishop": "Saint Ildephonsus of Toledo, Bishop",
    "saintIlltudAbbot": "Saint Illtud, Abbot",
    "saintIrenaeusBishopAndMartyr": "Saint Irenaeus, Bishop and Martyr",
    "saintIrene": "Saint Irene",
    "saintIsidoreOfSevilleBishopAndDoctorOfTheChurch": "Saint Isidore of Seville, Bishop and Doctor of the Church",
    "saintIsidoreTheFarmer": "Saint Isidore the Farmer",
    "saintItaVirgin": "Saint Ita, Virgin",
    "saintIvoPriest": "Saint Ivo, Priest",
    "saintJamesApostle": "Saint James, Apostle",
    "saintJamesApostlePatronOfSpain": "Saint James, Apostle, Patron of Spain",
    "saintJaneFrancesDeChantalReligious": "Saint Jane Frances de Chantal, Religious",
    "saintJanuariusBishopAndMartyr": "Saint Januarius, Bishop and Martyr",
    "saintJarlathBishop": "Saint Jarlath, Bishop",
    "saintJeanVianneyTheCureOfArsPriest": "Saint Jean Vianney (the Cure of Ars), Priest",
    "saintJeromeEmilianiSaintJosephineBakhitaVirgin": "Saint Jerome Emiliani and Saint Josephine Bakhita, Virgin",
    "saintJeromePriestAndDoctor": "Saint Jerome, Priest and Doctor",
    "saintJoachimHoMartyr": "Saint Joachim Ho, Martyr",
    "saintJoanOfArcVirginSecondaryPatronessOfFrance": "Saint Joan of Arc, Virgin, Secondary Patroness of France",
    "saintJoaquinaVedruna": "Saint Joaquina Vedruna",
    "saintJohnBaptistDeLaSallePriest": "Saint John Baptist de la Salle, Priest",
    "saintJohnBerchmansReligious": "Saint John Berchmans, Religious",
    "saintJohnBoscoPriest": "Saint John Bosco, Priest",
    "saintJohnCassianPriest": "Saint John Cassian, Priest",
    "saintJohnChrysostomBishopAndDoctor": "Saint John Chrysostom, Bishop and Doctor of the Church",
    "saintJohnDamascenePriestAndDoctor": "Saint John Damascene, Priest and Doctor",
    "saintJohnDamascenePriestAndDoctorOrSaintBarbaraVirginAndMartyr": "Saint John Damascene, Priest and Doctor, or Saint Barbara, Virgin and Martyr",
    "saintJohnDeBritoPriestAndMartyr": "Saint John de Brito, Priest and Martyr",
    "saintJohnEudesPriest": "Saint John Eudes, Priest",
    "saintJohnGabrielPerboyrePriestAndMartyr": "Saint John Gabriel Perboyre, Priest and Martyr",
    "saintJohnIPopeAndMartyr": "Saint John I, Pope and Martyr",
    "saintJohnJonesPriestAndMartyr": "Saint John Jones, Priest and Martyr",
    "saintJohnMaciasReligious": "Saint John Macias, Religious",
    "saintJohnNepomucenePriestAndMartyr": "Saint John Nepomucene, Priest and Martyr",
    "saintJohnNeumannBishop": "Saint John Neumann, Bishop",
    "saintJohnOfAvilaPriest": "Saint John of Avila, Priest",
    "saintJohnOfCapistranoPriest": "Saint John of Capistrano, Priest",
    "saintJohnOfDuklaPriest": "Saint John of Dukla, Priest",
    "saintJohnOfGodPriest": "Saint John of God, Priest",
    "saintJohnOfGodReligious": "Saint John of God, Religious",
    "saintJohnOfKantyPriest": "Saint John of Kenty, Priest",
    "saintJohnOfTheCrossDoctorOfTheChurch": "Saint John of The Cross, Doctor of The Church",
    "saintJohnOfTheCrossPriestAndDoctor": "Saint John of the Cross, Priest and Doctor",
    "saintJohnOfTrioraPriestAndMartyr": "Saint John of Triora, Priest and Martyr",
    "saintJohnOgilvie": "Saint John Ogilvie",
    "saintJohnRobertsPriestAndMartyr": "Saint John Roberts, Priest and Martyr",
    "saintJohnSarkanderPriestAndMartyrSaintZdzislawa": "Saint John Sarkander, Priest and Martyr/Saint Zdzislawa",
    "saintJohnTheApostleAndEvangelist": "Saint John the Apostle and Evangelist",
    "saintJosaphatBishopAndMartyr": "Saint Josaphat, Bishop and Martyr",
    "saintJoseDeAnchietaPriest": "Saint Jose de Anchieta, Priest",
    "saintJosefBilczewskiBishop": "Saint Josef Bilczewski, Bishop",
    "saintJoseMariaDeYermoPriest": "Saint Jose Maria de Yermo, Priest",
    "saintJosemariaEscrivaDeBalaguerPriest": "Saint Josemaria Escriva de Balaguer, Priest",
    "saintJosephSpouseOfTheBlessedVirginMaryPrincipalPatronOfCanada": "Saint Joseph, Spouse of The Blessed Virgin Mary, Principal Patron of Canada",
    "saintJosephTheWorker": "Saint Joseph the Worker",
    "saintJosephYuanPriestAndMartyr": "Saint Joseph Yuan, Priest and Martyr",
    "saintJosephZhangDapengMartyr": "Saint Joseph Zhang Dapeng, Martyr",
    "saintJozefBilczewskiBishop": "Saint Jozef Bilczewski, Bishop",
    "saintJozefSebastianPelczar": "Saint Jozef Sebastian Pelczar",
    "saintJuanDiego": "Saint Juan Diego",
    "saintJuanDiegoCuauhtlatoatzin": "Saint Juan Diego Cuauhtlatoatzin",
    "saintJulianaOfLiegeVirgin": "Saint Juliana of Liege, Virgin",
    "saintJulieBilliartVirgin": "Saint Julie Billiart, Virgin",
    "saintJustinMartyr": "Saint Justin Martyr",
    "saintKateriTekakwithaVirgin": "Saint Kateri Tekakwitha, Virgin",
    "saintKatharineDrexelVirgin": "Saint Katharine Drexel, Virgin",
    "saintKentigern": "Saint Kentigern",
    "saintKevinAbbot": "Saint Kevin, Abbot",
    "saintKieranBishop": "Saint Kieran, Bishop",
    "saintKilianBishopAndCompanionsMartyrs": "Saint Kilian, Bishop and Companions, Martyrs",
    "saintKillianBishopAndMartyr": "Saint Killian, Bishop and Martyr",
    "saintKingaVirgin": "Saint Kinga, Virgin",
    "saintLadislaus": "Saint Ladislaus",
    "saintLambertBishopAndMartyr": "Saint Lambert of Maastricht, Bishop and Martyr",
    "saintLaurenceOTooleBishop": "Saint Laurence O'Toole, Bishop",
    "saintLaurenceWangBingAndCompanionsMartyrsSaintJosephFreinademetzPriest": "Saint Laurence Wang Bing and Companions, Martyrs or Saint Joseph Freinademetz, Priest",
    "saintLawrenceBaiXiaomanMartyr": "Saint Lawrence Bai Xiaoman, Martyr",
    "saintLawrenceOfBrindisiPriestAndDoctor": "Saint Lawrence of Brindisi, Priest and Doctor",
    "saintLawrenceOfRomeDeaconAndMartyr": "Saint Lawrence of Rome, Deacon and Martyr",
    "saintLeanderBishop": "Saint Leander, Bishop",
    "saintLeobaAbbess": "Saint Leoba, Abbess",
    "saintLeoIxPopeOrBlessedMarcelCalloMartyr": "Saint Leo IX, Pope Or Blessed Marcel Callo, Martyr",
    "saintLeoManginPriestAndCompanionsMartyrs": "Saint Leo Mangin, Priest and Companions, Martyrs",
    "saintLeonardOfNoblacHermit": "Saint Leonard of Noblac, Hermit",
    "saintLeopoldIII": "Saint Leopold III",
    "saintLeopoldMandicPriest": "Saint Leopold Mandic, Priest",
    "saintLeoTheGreatPopeAndDoctor": "Saint Leo the Great, Pope and Doctor",
    "saintLorenzoRuizAndCompanionsMartyrs": "Saint Lorenzo Ruiz and Companions, Martyrs",
    "saintLouisBertrandPriest": "Saint Louis Bertrand, Priest",
    "saintLouisGrignonDeMontfortPriest": "Saint Louis Grignon de Montfort, Priest",
    "saintLouisSaintJosephOfCalasanzPriest": "Saint Louis/Saint Joseph of Calasanz, Priest",
    "saintLuciusOfChurBishopAndMartyr": "Saint Lucius of Chur, Bishop and Martyr",
    "saintLucyOfSyracuseVirginAndMartyr": "Saint Lucy of Syracuse, Virgin and Martyr",
    "saintLucyYiZhenmeiVirginAndMartyr": "Saint Lucy Yi Zhenmei, Virgin and Martyr",
    "saintLudgerBishop": "Saint Ludger, Bishop",
    "saintLudmilaMartyr": "Saint Ludmila, Martyr",
    "saintLuigiOrionePriest": "Saint Luigi Orione, Priest",
    "saintLukeTheEvangelist": "Saint Luke the Evangelist",
    "saintLydiaOfPhilippi": "Saint Lydia of Philippi",
    "saintMacartanBishop": "Saint Macartan, Bishop",
    "saintMacNissiBishop": "Saint Mac Nissi, Bishop",
    "saintMaelruainMaolruainVirgin": "Saint Maelruain (Maolruain), Virgin",
    "saintMagnusMartyr": "Saint Magnus, Martyr",
    "saintMalachyBishop": "Saint Malachy, Bishop",
    "saintMarcellinChampagnatPriest": "Saint Marcellin Champagnat, Priest",
    "saintMargaretMaryAlacoque": "Saint Msrgaret Mary Alacoque",
    "saintMargaretOfAntiochVirginAndMartyr": "Saint Margaret of Antioch, Virgin and Martyr",
    "saintMargaretOfHungary": "Saint Margaret of Hungary",
    "saintMargaretOfScotland": "Saint Margaret of Scotland",
    "saintMargaretOfScotlandSaintGertrudeTheGreatVirgin": "Saint Margaret of Scotland/Saint Gertrude the Great, Virgin",
    "saintMargueriteBourgeoysVirgin": "Saint Marguerite Bourgeoys, Virgin",
    "saintMargueriteDYouvilleReligious": "Saint Marguerite d'Youville, Religious",
    "saintMariaDeJesusSacramentadoVenegasVirgin": "Saint Maria de Jesus Sacramentado Venegas, Virgin",
    "saintMariaGorettiVirginAndMartyr": "Saint Maria Goretti, Virgin and Martyr",
    "saintMariaMicaelaOfTheBlessedSacramentVirgin": "Saint Maria Micaela of The Blessed Sacrament, Virgin",
    "saintMarianaDeJesusDeParedesVirgin": "Saint Mariana de Jesus de Paredes, Virgin",
    "saintMarieOfTheIncarnationReligious": "Saint Marie of The Incarnation, Religious",
    "saintMarina": "Saint Marina",
    "saintMarkApostle": "Saint Mark, Apostle",
    "saintMarkoKrizinPriestAndMartyr": "Saint Marko Krizin, Priest and Martyr",
    "saintMarkTheEvangelist": "Saint Mark the Evangelist",
    "saintMaroun": "Saint Maroun",
    "saintMartha": "Saint Martha",
    "saintMartinDePorresReligious": "Saint Martin de Porres, Religious",
    "saintMartinIPopeAndMartyr": "Saint Martin I, Pope and Martyr",
    "saintMartinOfToursBishop": "Saint Martin of Tours, Bishop",
    "saintMartinWuXueshengAndCompanionsMartyrs": "Saint Martin Wu Xuesheng and Companions, Martyrs",
    "saintMaryMacKillopVirgin": "Saint Mary MacKillop, Virgin",
    "saintMaryMagdalene": "Saint Mary Magdalene",
    "saintMaryOfTheCrossVirgin": "Saint Mary of The Cross, Virgin",
    "saintMatilda": "Saint Matilda",
    "saintMatthewApostleAndEvangelist": "Saint Matthew, Apostle and Evangelist",
    "saintMatthiasTheApostle": "Saint Matthias the Apostle",
    "saintMauriceAndCompanionsMartyrs": "Saint Maurice and Companions, Martyrs",
    "saintMaurusBishop": "Saint Maurus, Bishop",
    "saintMaximilianMaryKolbePriestAndMartyr": "Saint Maximilian Mary Kolbe, Priest and Martyr",
    "saintMeinradMartyr": "Saint Meinrad, Martyr",
    "saintMelBishop": "Saint Mel, Bishop",
    "saintMelchiorGrodzieckiPriestAndMartyr": "Saint Melchior Grodziecki, Priest and Martyr",
    "saintMiguelFebresCorderoReligious": "Saint Miguel Febres Cordero, Religious",
    "saintMolaiseLaisrenLaserianBishop": "Saint Molaise (Laisren, Laserian), Bishop",
    "saintMonica": "Saint Monica",
    "saintMoninneVirgin": "Saint Moninne, Virgin",
    "saintMuiredachBishopSaintAttractaVirginOrSaintLeliaVirgin": "Saint Muiredach, Bishop, Saint Attracta, Virgin, Or Saint Lelia, Virgin",
    "saintMunchinBishop": "Saint Munchin, Bishop",
    "saintNicholasBishop": "Saint Nicholas, Bishop",
    "saintNicholasOfFlueHermit": "Saint Nicholas of Flüe, Hermit",
    "saintNikolaTavelicPriestAndMartyr": "Saint Nikola Tavelic, Priest and Martyr",
    "saintNinian": "Saint Ninian",
    "saintNorbertBishop": "Saint Norbert, Bishop",
    "saintNunoDeSantaMaria": "Saint Nuno de Santa Maria",
    "saintOdileOfAlsaceAbbess": "Saint Odile of Alsace, Abbess",
    "saintOlafIiMartyr": "Saint Olaf II, Martyr",
    "saintOlga": "Saint Olga",
    "saintOliverPlunketBishopAndMartyr": "Saint Oliver Plunket, Bishop and Martyr",
    "saintOliverPlunkettBishopAndMartyr": "Saint Oliver Plunkett, Bishop and Martyr",
    "saintOtteranMonk": "Saint Otteran, Monk",
    "saintOttoOfBambergBishop": "Saint Otto of Bamberg, Bishop",
    "saintPantaleon": "Saint Pantaleon",
    "saintPaschalBaylon": "Saint Paschal Baylon",
    "saintPatrickBishop": "Saint Patrick, Bishop",
    "saintPaulChenChangpinAndCompanionsMartyrs": "Saint Paul Chen Changpin and Companions, Martyrs",
    "saintPaulinaOfTheAgonizingHeartOfJesusVirgin": "Saint Paulina of The Agonizing Heart of Jesus, Virgin",
    "saintPaulinusOfNolaBishopSaintsJohnFisherBishopAndThomasMoreMartyrs": "Saint Paulinus of Nola, Bishop/Saints John Fisher, Bishop and Thomas More, Martyrs",
    "saintPaulinusOfTrierBishop": "Saint Paulinus of Trier, Bishop",
    "saintPaulinusOfYorkBishop": "Saint Paulinus of York, Bishop",
    "saintPaulLiuHanzouPriestAndMartyr": "Saint Paul Liu Hanzou, Priest and Martyr",
    "saintPaulMikiAndCompanionsMartyrs": "Saint Paul Miki and Companions, Martyrs",
    "saintPaulOfTheCrossPriest": "Saint Paul of The Cross, Priest",
    "saintPedroCalungsodMartyr": "Saint Pedro Calungsod, Martyr",
    "saintPelagiusMartyr": "Saint Pelagius, Martyr",
    "saintPeterCanisiusPriestAndDoctor": "Saint Peter Canisius, Priest and Doctor",
    "saintPeterChanelPriestAndMartyrSaintLouisGrignonDeMontfortPriest": "Saint Peter Chanel, Priest and Martyr/Saint Louis Grignon de Montfort, Priest",
    "saintPeterChrysologusBishopAndDoctor": "Saint Peter Chrysologus, Bishop and Doctor",
    "saintPeterClaverPriest": "Saint Peter Claver, Priest",
    "saintPeterDamianBishopAndDoctorOfTheChurch": "Saint Peter Damian, Bishop and Doctor of the Church",
    "saintPeterLiuMartyr": "Saint Peter Liu, Martyr",
    "saintPeterOfAlcantaraPriest": "Saint Peter of Alcantara, Priest",
    "saintPeterSanzBishopAndMartyr": "Saint Peter Sanz, bishop and Martyr",
    "saintPeterWuMartyr": "Saint Peter Wu, Martyr",
    "saintPhilipNeriPriest": "Saint Philip Neri, Priest",
    "saintPioOfPietralcina": "Saint Pio of Pietralcina",
    "saintPioOfPietrelcinaPadrePioPriest": "Saint Pio of Pietrelcina (Padre Pio), Priest",
    "saintPiusVPope": "Saint Pius V, Pope",
    "saintPiusXPope": "Saint Pius X, Pope",
    "saintPolycarpBishopAndMartyr": "Saint Polycarp, Bishop and Martyr",
    "saintPothinusBishopSaintBlAndinaVirginAndTheirCompanionsMartyrs": "Saint Pothinus, Bishop, Saint Blandina, Virgin, and Their Companions, Martyrs",
    "saintProcopiusAbbot": "Saint Procopius, Abbot",
    "saintPubliusBishop": "Saint Publius, Bishop",
    "saintQuirinusOfSescia": "Saint Quirinus of Sescia",
    "saintRabanusMaurusBishop": "Saint Rabanus Maurus, Bishop",
    "saintRadimBishop": "Saint Radim, Bishop",
    "saintRafaelGuizarYValenciaBishop": "Saint Rafael Guizar y Valencia, Bishop",
    "saintRafalKalinowskiPriest": "Saint Rafal Kalinowski, Priest",
    "saintRafqaRebeccaVirgin": "Saint Rafqa (Rebecca), Virgin",
    "saintRaymondOfPenyafortPriest": "Saint Raymond of Penyafort, Priest",
    "saintRemigiusBishop": "Saint Remigius, Bishop",
    "saintRichardGwynMartyr": "Saint Richard Gwyn, Martyr",
    "saintRichardOfChichesterBishop": "Saint Richard of Chichester, Bishop",
    "saintRitaOfCascia": "Saint Rita of Cascia",
    "saintRobertBellarmineBishopAndDoctor": "Saint Robert Bellarmine, Bishop and Doctor of the Church",
    "saintRocco": "Saint Rocco",
    "saintRoch": "Saint Roch",
    "saintRomualdAbbot": "Saint Romuald, Abbot",
    "saintRoseOfLima": "Saint Rose of Lima, Virgin",
    "saintRosePhilippineDuchesneVirgin": "Saint Rose Philippine Duchesne, Virgin",
    "saintsAlbanJuliusAndAaronMartyrs": "Saints Alban, Julius and Aaron, Martyrs",
    "saintsAndrewZoerardusAndBenedictHermits": "Saints Andrew Zoerardus and Benedict, Hermits",
    "saintsAndrewZorardAndBenedictHermits": "Saints Andrew Zorard and Benedict, Hermits",
    "saintsAugustineZhaoRongPriestAndCompanionsMartyrs": "Saints Augustine Zhao Rong, Priest, and Companions, Martyrs",
    "saintsBasilTheGreatAndGregoryNazianzenBishopsAndDoctors": "Saints Basil the Great and Gregory Nazianzen, Bishops and Doctors",
    "saintsBenedyktJanMateuszIsaakAndKrystynMartyrs": "Saints Benedykt, Jan, Mateusz, Isaak and Krystyn, Martyrs",
    "saintsBorisAndGlebMartyrs": "Saints Boris and Gleb, Martyrs",
    "saintsCanuteEricAndOlafMartyrs": "Saints Canute, Eric and Olaf, Martyrs",
    "saintsChadAndCeddBishop": "Saints Chad and Cedd, Bishop",
    "saintsCharlesLwangaAndCompanionsMartyrs": "Saints Charles Lwanga and Companions, Martyrs",
    "saintScholasticaVirgin": "Saint Scholastica, Virgin",
    "saintsConradAndGebhardOfConstanceBishops": "Saints Conrad and Gebhard of Constance, Bishops",
    "saintsCorneliusPopeAndCyprianBishopMartyrs": "Saints Cornelius, Pope, and Cyprian, Bishop, Martyrs",
    "saintsCosmasAndDamian": "Saints Cosmas and Damian",
    "saintsCosmasAndDamianMartyrs": "Saints Cosmas and Damian, Martyrs",
    "saintsCyrilMonkAndMethodiusBishop": "Saints Cyril, Monk and Methodius, Bishop",
    "saintSenanBishop": "Saint Senan, Bishop",
    "saintSeverinusOfNoricumMonk": "Saint Severinus of Noricum, Monk",
    "saintsFabianPopeAndSebastianMartyrs": "Saints Fabian, Pope, and Sebastian, Martyrs",
    "saintsFelipeDeJesusPaulMikiAndCompanionsMartyrs": "Saints Felipe de Jesus, Paul Miki and Companions, Martyrs",
    "saintsFructuosusBishopAndAuguriusAndEulogiusDeaconsMartyrs": "Saints Fructuosus, Bishop, and Augurius and Eulogius, Deacons, Martyrs",
    "saintsGregoryGrassiFrancisFogollaAndAnthonyFantosatiBishopsAndCompanionsMartyrs": "Saints Gregory Grassi, Francis Fogolla and Anthony Fantosati, Bishops and Companions, Martyrs",
    "saintsHenryAndCunigunde": "Saints Henry and Cunigunde",
    "saintSigismundMartyr": "Saint Sigismund, Martyr",
    "saintSimonOfLipnicaPriest": "Saint Simon of Lipnica, Priest",
    "saintSixtusIiPopeAndCompanionsMartyrsSaintCajetanPriest": "Saint Sixtus II, Pope, and Companions, Martyrs/Saint Cajetan, Priest",
    "saintsJeanDeBrebeufAndIsaacJoguesPriestsAndCompanionsMartyrsSaintPaulOfTheCrossPriest": "Saints Jean de Brebeuf and Isaac Jogues, Priests and Companions, Martyrs/Saint Paul of the Cross, Priest",
    "saintsJoachimAndAnne": "Saints Joachim and Anne",
    "saintsJohnFisherBishopAndThomasMoreMartyrs": "Saints John Fisher, Bishop and Thomas More, Martyrs",
    "saintsLawrenceRuizAndCompanionsMartyrs": "Saints Lawrence Ruiz and Companions, Martyrs",
    "saintsLouisVersigliaBishopAndCallistusCaravarioPriestMartyrs": "Saints Louis Versiglia, Bishop and Callistus Caravario, Priest, Martyrs",
    "saintsMarcellinusAndPeterMartyrs": "Saints Marcellinus and Peter, Martyrs",
    "saintsMargaretClitherowAnneLineAndMargaretWardMartyrs": "Saints Margaret Clitherow, Anne Line and Margaret Ward, Martyrs",
    "saintsMarkoKrizinMelicharGrodeckiAndStephenPongracPriestsAndMartyrs": "Saints Marko Krizin, Melichar Grodecki and Stephen Pongrac, Priests and Martyrs",
    "saintsMichaelGabrielAndRaphaelArchangels": "Saints Michael, Gabriel and Raphael, Archangels",
    "saintsNereusAndAchilleusMartyrsSaintPancrasMartyr": "Saints Nereus and Achilleus, Martyrs/Saint Pancras, Martyr",
    "saintSoledadTorresAcostaVirgin": "Saint Soledad Torres Acosta, Virgin",
    "saintsPedroBautistaPaulMikiAndCompanionsMartyrs": "Saints Pedro Bautista, Paul Miki and Companions, Martyrs",
    "saintsPerpetuaAndFelicityMartyrs": "Saints Perpetua and Felicity, Martyrs",
    "saintsPhilipAndJamesApostles": "Saints Philip and James, Apostles",
    "saintsPhilipEvansAndJohnLloydPriestsAndMartyrs": "Saints Philip Evans and John Lloyd, Priests and Martyrs",
    "saintsPontianPopeAndHippolytusPriestMartyrs": "Saints Pontian, Pope and Hippolytus, Priest, Martyrs",
    "saintSpyridon": "Saint Spyridon",
    "saintsRoqueGonzalezAlfonsoRodriguezOlmedoAndJuanDelCastilloPriestsAndMartyrs": "Saints Roque Gonzalez, Alfonso Rodriguez Olmedo, and Juan del Castillo, Priests and Martyrs",
    "saintsRupertAndVirgiliusOfSalzburgBishops": "Saints Rupert and Virgilius of Salzburg, Bishops",
    "saintsSimonAndJudeApostles": "Saints Simon and Jude, Apostles",
    "saintStanislausBishopAndMartyr": "Saint Stanislaus, Bishop and Martyr",
    "saintStanislausKazimierczykPriest": "Saint Stanislaus Kazimierczyk, Priest",
    "saintStanislausKostkaReligious": "Saint Stanislaus Kostka, Religious",
    "saintStephenOfHungary": "Saint Stephen of Hungary",
    "saintStephenTheFirstMartyr": "Saint Stephen, The First Martyr",
    "saintsTimothyAndTitusBishops": "Saints Timothy and Titus, Bishops",
    "saintSunnivaVirginAndMartyr": "Saint Sunniva, Virgin and Martyr",
    "saintSwithunBishop": "Saint Swithun, Bishop",
    "saintSylvesterIPope": "Saint Sylvester I, Pope",
    "saintTeiloBishop": "Saint Teilo, Bishop",
    "saintTeresaBenedictaOfTheCrossEdithSteinVirginAndMartyr": "Saint Teresa Benedicta of The Cross (Edith Stein), Virgin and Martyr, Patron of Europe",
    "saintTeresaOfCalcuttaReligious": "Saint Teresa of Calcutta, Religious",
    "saintTeresaOfJesusJornetEIbarsVirgin": "Saint Teresa of Jesus Jornet e Ibars, Virgin",
    "saintTeresaOfJesusVirginAndDoctorOfTheChurch": "Saint Teresa of Jesus, Virgin and Doctor",
    "saintTeresaOfLosAndesVirgin": "Saint Teresa of Los Andes, Virgin",
    "saintTheodoreOfCanterburyBishop": "Saint Theodore of Canterbury, Bishop",
    "saintTheodosiusOfTheCavesAbbot": "Saint Theodosius of The Caves, Abbot",
    "saintTheotoniusPriest": "Saint Theotonius, Priest",
    "saintThereseOfTheChildJesusVirginAndDoctor": "Saint Therese of the Child Jesus, Virgin and Doctor",
    "saintThereseOfTheChildJesusVirginSecondaryPatronessOfFrance": "Saint Therese of The Child Jesus, Virgin, Secondary Patroness of France",
    "saintThomasAquinasPriestAndDoctor": "Saint Thomas Aquinas, Priest and Doctor",
    "saintThomasBecketBishopAndMartyr": "Saint Thomas Becket, Bishop and Martyr",
    "saintThomasOfVillanovaBishop": "Saint Thomas of Villanova, Bishop",
    "saintThomasRokuzayemonPriestAndCompanionsMartyrs": "Saint Thomas Rokuzayemon, Priest and Companions, Martyrs",
    "saintThomasTheApostle": "Saint Thomas the Apostle",
    "saintThorfinnBishop": "Saint Thorfinn, Bishop",
    "saintThorlacBishop": "Saint Thorlac, Bishop",
    "saintTuribiusOfMogrovejoBishop": "Saint Turibius of Mogrovejo, Bishop",
    "saintUlrichOfAugsburg": "Saint Ulrich of Augsburg",
    "saintUrsulaAndCompanionsVirginsAndMartyrs": "Saint Ursula and Companions, Virgins and Martyrs",
    "saintUrsulaLedochowskaVirgin": "Saint Ursula Ledochowska, Virgin",
    "saintValentineOfRaetiaBishop": "Saint Valentine of Raetia, Bishop",
    "saintVincentDeaconAndMartyr": "Saint Vincent, Deacon and Martyr",
    "saintVincentDeaconAndMartyrOrSaintMarianneCopeVirgin": "Saint Vincent, Deacon and Martyr Or Saint Marianne Cope, Virgin",
    "saintVincentDePaulPriest": "Saint Vincent de Paul, Priest",
    "saintVincentFerrerPriest": "Saint Vincent Ferrer, Priest",
    "saintVincentPallottiPriest": "Saint Vincent Pallotti, Priest",
    "saintVitusMartyr": "Saint Vitus, Martyr",
    "saintVladimirTheGreat": "Saint Vladimir The Great",
    "saintWalburgaAbbess": "Saint Walburga, Abbess",
    "saintWenceslausMartyr": "Saint Wenceslaus, Martyr",
    "saintWenceslausMartyrSaintsLawrenceRuizAndCompanionsMartyrs": "Saint Wenceslaus, Martyr/Saints Lawrence Ruiz and Companions, Martyrs",
    "saintWendelinAbbot": "Saint Wendelin, Abbot",
    "saintWilfridBishop": "Saint Wilfrid, Bishop",
    "saintWillibaldBishop": "Saint Willibald, Bishop",
    "saintWillibrordBishop": "Saint Willibrord, Bishop",
    "saintWinefrideVirgin": "Saint Winefride, Virgin",
    "saintWolfgangBishop": "Saint Wolfgang, Bishop",
    "saintWolfgangOfRegensburgBishop": "Saint Wolfgang of Regensburg, Bishop",
    "saintWulstanBishop": "Saint Wulstan, Bishop",
    "saintZdislava": "Saint Zdislava",
    "saintZygmuntGorazdowskiPriest": "Saint Zygmunt Gorazdowski, Priest",
    "saintZygmuntSzczesnyFelinskiBishop": "Saint Zygmunt Szczesny Felinski, Bishop",
    "santoNinoInfantJesus": "Santo Nino (Infant Jesus)",
    "sevenHolyFoundersOfTheServiteOrder": "Seven Holy Founders of the Servite Order",
    "sevenMartyredNunsFromTheFranciscanMissionariesOfMary": "Seven Martyred Nuns from the Franciscan Missionaries of Mary",
    "shipwreckOfSaintPaulApostle": "Shipwreck of Saint Paul, Apostle",
    "shroveMonday": "Shrove Monday",
    "shroveTuesday": "Shrove Tuesday",
    "stDunstanArchbishopOfCanterbury": "St Dunstan, Archbishop of Canterbury",
    "theBeheadingOfSaintJohnTheBaptistMartyr": "The Beheading of Saint John the Baptist, Martyr",
    "theEnglishMartyrs": "The English Martyrs",
    "theFiveWoundsOfTheLord": "The Five Wounds of The Lord",
    "theMostHolyNameOfJesus": "The Most Holy Name of Jesus",
    "theSixWelshMartyrsAndCompanions": "The Six Welsh Martyrs and Companions",
    "transferOfTheRelicsOfSaintStephen": "Transfer of The Relics of Saint Stephen",
    "vietnameseMartyrs": "Vietnamese Martyrs",
    "visitationOfTheBlessedVirginMary": "Visitation of the Blessed Virgin Mary",
    "waitangiDay": "Waitangi Day"
  }
};
